import { watch } from 'vue'

import { notification } from '@/lib/helpers'
import { useErrorStore } from '@/stores/error'

export function useErrorNotification() {
  const errorStore = useErrorStore()

  watch(
    () => errorStore.errorMessage,
    (newMessage) => {
      if (newMessage) {
        notification.error(newMessage)
        errorStore.clearError()
      }
    },
  )
}
